/**
 * The one-line auth notice and the 2FA status shape — split out of
 * SecondFactorPanel so the sign-in card can show a message without pulling
 * the whole second-factor panel into every visitor's first download (the
 * panel is lazy; this is not).
 */
import { cn } from "@/lib/utils";

export interface TwoFactorStatusResponse {
  required?: boolean;
  passkeyAvailable?: boolean;
  totpEnabled?: boolean;
  recoveryCodesRemaining?: number;
  emailHint?: string | null;
  /** The company accepts only a passkey or an authenticator app (WS5-B5). */
  strongRequired?: boolean;
  /** …and this person has neither yet. */
  strongSetup?: boolean;
}

/* ───────────────────────────── a message line ───────────────────────────── */

/**
 * The one-line notice every auth panel uses: an error (announced), or a quiet
 * note. Shared by the sign-in card so the two look the same.
 */
export function AuthMessage({
  tone = "error",
  children,
  className,
  testId,
}: {
  tone?: "error" | "info" | "success";
  children: React.ReactNode;
  className?: string;
  testId?: string;
}) {
  return (
    <p
      role={tone === "error" ? "alert" : "status"}
      data-testid={testId}
      className={cn(
        "rounded border px-3 py-2 text-label",
        tone === "error" && "border-on-tint-destructive/25 bg-tint-destructive font-semibold text-on-tint-destructive",
        tone === "success" && "border-on-tint-success/25 bg-tint-success text-on-tint-success",
        tone === "info" && "border-border bg-foreground/[.02] text-muted-foreground",
        className,
      )}
    >
      {children}
    </p>
  );
}

